import React from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import translations from './translations'
import get from 'lodash/get'
// UI
import styles from './main.scss'
import cookie from './cookie.svg'
import { Accordion } from './Accordion'
import { IntegrationToggle } from './Accordion/IntegrationToggle'
import { getIntegrationsByCategory } from './helper'
import { integrations, integrationsToDisplayName } from '../../../globals/tracking/integrations'
import { graphql, Link, StaticQuery } from 'gatsby'

class ExplicitCookie extends React.PureComponent {
  constructor(props) {
    super(props)
    const { data } = props

    this.state = {
      integrations: {
        [integrationsToDisplayName[integrations.facebookPixel]]: false,
        [integrationsToDisplayName[integrations.googleTagManager]]: false,
        [integrationsToDisplayName[integrations.adwords]]: false,
        [integrationsToDisplayName[integrations.hubspot]]: false,
        [integrationsToDisplayName[integrations.googleAnalytics]]: false,
        [integrationsToDisplayName[integrations.media]]: false,
      },
    }

    this.legalLink = get(data, 'campaignData.footerId.content.legalLink')
    this.termsLink = get(data, 'campaignData.footerId.content.termsLink')
  }

  get showSelectionButton() {
    const { integrations } = this.props

    return integrations.length > 0
  }

  get marketingIntegrations() {
    const { integrations } = this.props

    return getIntegrationsByCategory(integrations, 'marketing')
  }

  get analyticsIntegrations() {
    const { integrations } = this.props

    return getIntegrationsByCategory(integrations, 'analytics')
  }

  get marketingCategoryEnabled() {
    return !this.marketingIntegrations.some((integration) => this.state.integrations[integration] === false)
  }

  get analyticsCategoryEnabled() {
    return !this.analyticsIntegrations.some((integration) => this.state.integrations[integration] === false)
  }

  get mediaCategoryEnabled() {
    return this.state.integrations[integrationsToDisplayName[integrations.media]]
  }

  get showMediaCategory() {
    const { integrations } = this.props

    return integrations.includes(integrationsToDisplayName['media'])
  }

  get showRequiredToggle() {
    return this.marketingIntegrations.length > 0 || this.marketingIntegrations.length > 0 || this.showMediaCategory
  }

  componentDidMount() {
    const { integrations, storedIntegrations } = this.props
    const updatedIntegrations = Object.assign({}, this.state.integrations)

    integrations.forEach((integration) => {
      if (storedIntegrations[integration]) {
        updatedIntegrations[integration] = storedIntegrations[integration]
      }
    })

    this.setState({ integrations: updatedIntegrations })
  }

  handleAccept = () => {
    const { loadAnalytics, integrations } = this.props
    const integrationsToLoad = {}

    integrations.forEach((integration) => {
      integrationsToLoad[integration] = true
    })

    loadAnalytics(integrationsToLoad)

    this.setState({
      integrations: {
        [integrationsToDisplayName[integrations.facebookPixel]]: true,
        [integrationsToDisplayName[integrations.googleTagManager]]: true,
        [integrationsToDisplayName[integrations.adwords]]: true,
        [integrationsToDisplayName[integrations.hubspot]]: true,
        [integrationsToDisplayName[integrations.googleAnalytics]]: true,
      },
    })
  }

  handleAcceptSelection = () => {
    const { loadAnalytics } = this.props
    loadAnalytics(this.state.integrations)
  }

  handleCategoryToggle = (name, value) => {
    const { integrations } = this.props
    const updatedIntegrations = Object.assign({}, this.state.integrations)
    const integrationsToUpdate = getIntegrationsByCategory(integrations, name)

    integrationsToUpdate.forEach((integration) => {
      updatedIntegrations[integration] = value
    })

    this.setState({ integrations: updatedIntegrations })
  }

  handleIntegrationToggle = (name, value) => {
    this.setState({
      integrations: {
        ...this.state.integrations,
        [name]: value,
      },
    })
  }

  render() {
    const { language, disableCookiePoliciesLink } = this.props

    return (
      <div className={styles.backdrop}>
        <div className={styles.cookieWrapper}>
          <div className={styles.content}>
            <img src={cookie} alt="" className={styles.cookie} />
            <p className={styles.headline}>{translations[language].headline}</p>
            <p className={styles.intro}>
              {translations[language].introText} <br />
              {this.legalLink && (
                <a href={this.legalLink} className={styles.link} target="_blank" rel="noopener norefferer">
                  {translations[language].imprint}
                </a>
              )}
              {this.termsLink && (
                <a href={this.termsLink} className={styles.link} target="_blank" rel="noopener norefferer">
                  {translations[language].privacy}
                </a>
              )}
              {!disableCookiePoliciesLink && (
                <Link to="/cookie-policy" className={styles.link}>
                  {translations[language].cookieLink}
                </Link>
              )}
            </p>
            <div className={styles.selection}>
              <Accordion
                title={translations[language].cookies.required.title}
                disabledToggle={this.showRequiredToggle}
                active
                language={language}
              >
                <div className={styles.description}>{translations[language].cookies.required.description}</div>
              </Accordion>
              {this.marketingIntegrations.length > 0 && (
                <Accordion
                  title={translations[language].cookies.marketing.title}
                  onToggle={this.handleCategoryToggle}
                  categoryId={'marketing'}
                  active={this.marketingCategoryEnabled}
                  language={language}
                >
                  <div className={styles.description}>
                    {translations[language].cookies.marketing.description}
                    {this.marketingIntegrations.map((integration) => (
                      <IntegrationToggle
                        key={integration}
                        text={integration}
                        id={integration}
                        language={language}
                        onToggle={this.handleIntegrationToggle}
                        active={this.state.integrations[integration]}
                      />
                    ))}
                  </div>
                </Accordion>
              )}
              {this.analyticsIntegrations.length > 0 && (
                <Accordion
                  title={translations[language].cookies.analytics.title}
                  onToggle={this.handleCategoryToggle}
                  categoryId={'analytics'}
                  active={this.analyticsCategoryEnabled}
                  language={language}
                >
                  <div className={styles.description}>
                    {translations[language].cookies.marketing.description}
                    {this.analyticsIntegrations.map((integration) => (
                      <IntegrationToggle
                        key={integration}
                        text={integration}
                        id={integration}
                        language={language}
                        onToggle={this.handleIntegrationToggle}
                        active={this.state.integrations[integration]}
                      />
                    ))}
                  </div>
                </Accordion>
              )}
              {this.showMediaCategory && (
                <Accordion
                  title={translations[language].cookies.media.title}
                  onToggle={this.handleCategoryToggle}
                  categoryId={'media'}
                  active={this.mediaCategoryEnabled}
                  language={language}
                >
                  <div className={styles.description}>{translations[language].cookies.media.description}</div>
                </Accordion>
              )}
            </div>
            <div className={styles.actions}>
              <div className={styles.button} onClick={this.handleAccept}>
                {translations[language].acceptAll}
              </div>
              {this.showSelectionButton && (
                <div className={cn(styles.button, styles.secondary)} onClick={this.handleAcceptSelection}>
                  {translations[language].acceptSelection}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

ExplicitCookie.propTypes = {
  campaignId: PropTypes.string.isRequired,
  language: PropTypes.oneOf(['de', 'en']),
  integrations: PropTypes.array.isRequired,
  storedIntegrations: PropTypes.object,
  loadAnalytics: PropTypes.func.isRequired,
  adjustIntegrations: PropTypes.func.isRequired,
  disableCookiePoliciesLink: PropTypes.bool,
}

ExplicitCookie.defaultProps = {
  storedIntegrations: {},
  disableCookiePoliciesLink: false,
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        campaignData {
          footerId {
            content {
              termsLink
              legalLink
            }
          }
        }
      }
    `}
    render={(data) => <ExplicitCookie data={data} {...props} />}
  />
)
